<template>
    <ModalBase
        name="error-copiar-invitaciones"
        title="Asientos ya ocupados"
        subtitle="Estos pedidos no se han podido volver a generar."
        :width="640"
        @close="$emit('close')"
    >
        <div class="tw:flex tw:flex-col tw:gap-4">
            <div class="tw:flex tw:items-start tw:gap-3 tw:rounded-lg tw:border tw:border-red-200 tw:bg-red-50 tw:p-3">
                <i class="fas fa-exclamation-triangle tw:mt-0.5 tw:text-red-600" aria-hidden="true"></i>
                <p class="tw:m-0 tw:text-sm tw:text-red-800">
                    Los siguientes pedidos no se han podido generar porque sus asientos ya estaban ocupados.
                </p>
            </div>

            <ul
                v-if="errors.length"
                class="tw:m-0 tw:flex tw:flex-col tw:divide-y tw:divide-gray-100 tw:rounded-lg tw:border tw:border-gray-200 tw:p-0 tw:list-none"
            >
                <li
                    v-for="pedido in errors"
                    :key="pedido.id"
                    class="tw:flex tw:items-center tw:gap-3 tw:px-4 tw:py-2.5"
                >
                    <span class="tw:shrink-0 tw:text-sm tw:font-semibold tw:text-gray-800">
                        {{ pedido.id }}
                    </span>
                    <span class="tw:min-w-0 tw:flex-1 tw:truncate tw:text-sm tw:text-gray-500">
                        {{ conceptoDe(pedido) }}
                    </span>
                    <Pill variant="red" size="sm" class="tw:shrink-0">
                        {{ etiquetaEntradas(pedido) }}
                    </Pill>
                </li>
            </ul>
        </div>

        <template #footer>
            <Button variant="primary" data-cy="cerrar-error-invitaciones" @click="$emit('close')">
                Entendido
            </Button>
        </template>
    </ModalBase>
</template>

<script setup>
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import Pill from '@/modules/admin/ui/Pill.vue';

    defineProps({
        errors: {
            type: Array,
            default: () => []
        }
    });

    defineEmits(['close']);

    const conceptoDe = pedido =>
        pedido.entradas && pedido.entradas[0] ? pedido.entradas[0].concept : '';

    const etiquetaEntradas = pedido => {
        const total = (pedido.entradas || []).length;
        return `${total} ${total === 1 ? 'entrada' : 'entradas'}`;
    };
</script>
